import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BeeSoftProvider, Localization, TestTagContext } from '@myosh/odin-components';
import reportWebVitals from './report-web-vitals';
import { trackWebVital } from './utils/analytics-utils';
import { Provider } from 'react-redux';
import store from './redux/store';
import { AuthProvider, UserProvider } from '@myosh/myosh-login';
import { BrowserRouter, HashRouter } from 'react-router';
import Meta from './features/meta/meta';
import Notifications from './components/notifications/notifications.component';
import i18next from './i18n';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './components/layout/routes/error-fallback.component';
import { HelmetProvider } from 'react-helmet-async';
import { isWebView } from './redux/util/webview-base-query';

const Router = isWebView() ? HashRouter : BrowserRouter;

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Provider store={store}>
          <Router basename={process.env.PUBLIC_URL}>
            <AuthProvider>
              <UserProvider>
                <Localization i18n={i18next}>
                  <BeeSoftProvider
                    isValidScrollableElement={(element) => element.dataset.skipScrollElement === undefined}
                  >
                    <TestTagContext.Provider value={{ isTesting: Boolean(process.env.REACT_APP_GENERATE_TEST_TAG) }}>
                      <Meta />
                      <App />
                      <Notifications />
                    </TestTagContext.Provider>
                  </BeeSoftProvider>
                </Localization>
              </UserProvider>
            </AuthProvider>
          </Router>
        </Provider>
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

// Send Web Vitals metrics to Google Analytics for performance monitoring
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals(trackWebVital);
